import { translateLabel } from "./runtime";

const categoryLabels = {
  "soft drinks": "input_category_soft_drinks",
  "main courses": "input_category_main_courses",
  appetizers: "input_category_appetizers",
  desserts: "input_category_desserts",
};

// Translate the four standard category names at display time. Keep API names,
// identifiers, custom category names and submitted values unchanged.
export function translateRestaurantCategory(name) {
  if (typeof name !== "string") return name;
  const id = categoryLabels[name.trim().replace(/\s+/g, " ").toLowerCase()];
  return id ? translateLabel(id, name) : name;
}
